import { render, staticRenderFns } from "./EmpresaTabelaGestaoPY.vue?vue&type=template&id=3daa9c4e&lang=pug"
import script from "./EmpresaTabelaGestaoPY.vue?vue&type=script&lang=js"
export * from "./EmpresaTabelaGestaoPY.vue?vue&type=script&lang=js"
import style0 from "./EmpresaTabelaGestaoPY.vue?vue&type=style&index=0&id=3daa9c4e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports